import { CSSProperties } from "react";

// eslint-disable-next-line import/prefer-default-export
export const MenuButtonStyle: CSSProperties = {
    margin: '0 4px',
    border: '1px solid',
    borderRadius: '4px'
    // flex: 1
}
